// WAIT_SELLER_AGREE 等待卖家同意
// REFUND_SUCCESS 退款成功
// REFUND_CLOSED 退款关闭
// WAIT_BUYER_MODIFY 待买家修改
// WAIT_BUYER_SEND 等待买家退货
// WAIT_SELLER_RECEIVE 等待卖家确认收货

export const refundStatusEnum = {
  WAIT_SELLER_AGREE: '等待賣家同意',
  REFUND_SUCCESS: '退款成功',
  REFUND_CLOSED: '退款關閉',
  WAIT_BUYER_MODIFY: '待買家修改',
  WAIT_BUYER_SEND: '等待買家退貨',
  WAIT_SELLER_RECEIVE: '等待賣家確認收貨',
}

/**
 * 消息是否包含其他第三方集运商地址
 * @param {string} msg
 * @returns {boolean}
 */
export function msgHasOtherAddr (msg) {
  if (!msg) return false

  // 判断是否包含省市地址格式，省市之间允许有空格
  const hasProvinceCity = /[^\s]*省\s*[^\s]*市/.test(msg)

  // 判断是否包含集运商地址
  const addrDescText = window.vueApp.$store.state.jyWarehouses.map(item => {
    return item.desc
  })

  // 如果包含省市格式，且不包含任何一个第三方集运商地址，则返回true
  return hasProvinceCity && !addrDescText.some(item => msg.indexOf(item) > -1)
}
